module.exports = __webpack_public_path__ + "img/security-icon.b6955f6d.jpg";